import { render } from "./PVC40.vue?vue&type=template&id=91ea555a&scoped=true"
import script from "./PVC40.vue?vue&type=script&lang=js"
export * from "./PVC40.vue?vue&type=script&lang=js"

import "./PVC40.vue?vue&type=style&index=0&id=91ea555a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ea555a"]])

export default __exports__